'use strict';

var transformDateTimePartNumberToStringWithZeroPadding = require('../common/transformDateTimePartNumberToStringWithZeroPadding.cjs');

const assemblePartsToISODatePart = (dateParts) => {
  return [
    transformDateTimePartNumberToStringWithZeroPadding(dateParts.year, 4),
    transformDateTimePartNumberToStringWithZeroPadding(dateParts.month),
    transformDateTimePartNumberToStringWithZeroPadding(dateParts.day)
  ].join("-");
};

module.exports = assemblePartsToISODatePart;
//# sourceMappingURL=assemblePartsToISODatePart.cjs.map
